// import React, { useState } from "react";
import { ref, onValue, get, push, set } from "firebase/database";
import database from "../firebase";
import React, { useEffect, useState } from "react";
import style from "../stylees/add.module.css";
const SignUP = () => {
  let [message, setMessage] = useState("");
  let [messageType, setMessageType] = useState("alert-success");
    const [custom_date, setCustom_date] = useState(
      new Date().toLocaleDateString("en-GB").split("/").reverse().join("-")
    );
  const [Button_display, setButton_display] = useState("");
  const [doctors, setDoctors] = useState([]);
  let [loader, setLoader] = useState(true);
  useEffect(() => {
    document.title = "Add Patient";
  }, []);
  let [user_info, setUser_info] = useState({
    Name: "",
    state: "waiting",
    fileNo: "",
    ward: "",
    doctor: "",
    history: "",
    procedure: "",
    injection: "-",
    Examination: "-",
    gender: "",
    note:"",
    date: custom_date,
  });
  const HandleSumbit = (e) => {
    setMessage("");
    const { name, value } = e.target;
    setUser_info((old) => ({
      ...old,
      [name]: value,
    }));
    console.log(user_info);
  };
  let goToNextPage = (e) => {
    e.preventDefault();

    AddUser();
  };
  function addPatient(userInfo) {
    const patientsRef = ref(database, "patients");
    const newPatientRef = push(patientsRef); // Generate a new reference with a unique ID
    return set(newPatientRef, {
      name: userInfo.Name,
      fileNo: userInfo.fileNo,
      gender: userInfo.gender,
      doctor: userInfo.doctor,
      state: userInfo.state,
      procedure: userInfo.procedure,
      history: userInfo.history,
      ward: userInfo.ward,
      injection: userInfo.injection,
      Examination: userInfo.Examination,
      note:userInfo.note,
      date: userInfo.date,
    });
  }
  let getDoctors = () => {
    const DoctorsRef = ref(database, "Doctors");
    const unsubscribe = onValue(
      DoctorsRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const formattedData = Object.entries(data).map(([id, values]) => ({
            id,
            ...values,
          }));
          setDoctors(formattedData);
          setLoader(false);
        } else {
          setDoctors([]);
        }
      },
      (error) => {
        setLoader(false);
        console.error("Error fetching Doctors:", error);
      }
    );
    return () => unsubscribe();
  };
  const AddUser = () => {
    setButton_display("disabled");
    setMessage("");
    addPatient(user_info)
      .then(() => {
        setButton_display("");
        setMessage("Patient added successfully!");
        setUser_info({
          Name: "",
          state: "waiting",
          fileNo: "",
          ward: "",
          doctor: "",
          history: "",
          procedure: "",
          injection: "-",
          Examination: "-",
          note:"",
          gender: "",
        });
      })
      .catch((error) => {
        // user_info.date=""
        setMessageType("alert-danger");
        setMessage("Error adding patient");
        setButton_display("");
        console.error("Error adding patient:", error);
      });
  };
  useEffect(() => {
    getDoctors();
  }, []);
  return (
    <div className={`${style.body}`}>
      <div className={`container p-4`}>
        <div
          className={`${style.foir} container col-lg-8 col-sm-12 py-3 bg-white rounded-4 `}
        >
          <h2 className="text-center mb-4">Add Patient </h2>
          <form className="row g-3 col-md-10 mx-auto" onSubmit={goToNextPage}>
          <div className="">
          <label htmlFor="date" className="form-label">
               Date
              </label>
          <input
            className={`form-control ${style.inputChange}`}
            type="date"
            name="date"
            id="date"
            min={new Date().toISOString().split("T")[0]}
            value={custom_date}
            onChange={(e) => {setCustom_date(e.target.value); HandleSumbit(e)}}
          />
        </div>
            {/* name input */}
            <div className="col-md-12">
              <label htmlFor="user_name" className="form-label">
                Name
              </label>
              <input
                type="text"
                className={`form-control ${style.inputChange}`}
                name="Name"
                id="Name"
                placeholder="enter the patient name"
                aria-describedby="inputGroupPrepend2"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("برجاء ادخال اسم  صحيح")
                }
                onInput={(e) => e.target.setCustomValidity("")}
                value={user_info.Name}
                onChange={HandleSumbit}
              />
            </div>
            {/* File No */}
            <div className="col-md-12">
              <label htmlFor="file" className="form-label">
                file no
              </label>
              <input
                type="text"
                className={`form-control ${style.inputChange}`}
                name="fileNo"
                id="file"
                placeholder="enter the patient file number"
                aria-describedby="inputGroupPrepend2"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("برجاء ادخال  رقم الملف  ")
                }
                onInput={(e) => e.target.setCustomValidity("")}
                value={user_info.fileNo}
                onChange={HandleSumbit}
              />
            </div>
            {/* procedure */}
            <div className="col-12 col-md-6">
              <label htmlFor="procedure" className="form-label">
                procedure
              </label>
              <select
                className="form-select"
                id="procedure"
                onChange={(e) => {
                  HandleSumbit(e);
                }}
                required
                name="procedure"
                value={user_info.procedure}
              >
                <option selected disabled value="">
                  Select a procedure
                </option>
                <option value="AMYLOID STUDY">AMYLOID STUDY</option>
                <option value="Bone Scan">Bone Scan</option>
                <option value="Cardiac Redistribution Tl201">
                  Cardiac Redistribution Tl201
                </option>
                <option value="Cardiac Rest Tl201">Cardiac Rest Tl201</option>
                <option value="Cardiac STRESS Tl201">
                  Cardiac STRESS Tl201
                </option>
                <option value="Cardiac Viability Tl201">
                  Cardiac Viability Tl201
                </option>
                <option value="DMSA Scan">DMSA Scan</option>
                <option value="FDG-F18">FDG-F18</option>
                <option value="Gallium Scan">Gallium Scan</option>
                <option value="Gastric Empting">Gastric Empting</option>
                <option value="Gastroesophageal Reflux">
                  Gastroesophageal Reflux
                </option>
                <option value="Gastrointestinal Bleed">
                  Gastrointestinal Bleed
                </option>
                <option value="HIDA Scan (Hepatobiliary or Gallbadder)">
                  HIDA Scan (Hepatobiliary or Gallbadder)
                </option>
                <option value="I131 WBS">I131 WBS</option>
                <option value="Lung Perfusion">Lung Perfusion</option>
                <option value="Lung Ventilation">Lung Ventilation</option>
                <option value="Lymphoscintigraphy">Lymphoscintigraphy</option>
                <option value="Meckel's Diverticulum">
                  Meckel's Diverticulum
                </option>
                <option value="MIBG I131">MIBG I131</option>
                <option value="MPI Rest Tc99m MIBI">MPI Rest Tc99m MIBI</option>
                <option value="MPI Stress Tc99m MIBI">
                  MPI Stress Tc99m MIBI
                </option>
                <option value="Octreotide Tc99m Scan">
                  Octreotide Tc99m Scan
                </option>
                <option value="Parathyroid Scan">Parathyroid Scan</option>
                <option value="Renal Scan">Renal Scan</option>
                <option value="SLN">SLN</option>
                <option value="Thyroid Scan">Thyroid Scan</option>
                <option value="V/Q">V/Q</option>
              </select>
            </div>
            {/* doctor selection */}
            <div className="col-12 col-md-6">
              <label htmlFor="doctor" className="form-label">
                Doctors
              </label>
              <select
                className="form-select"
                id="doctor"
                onChange={(e) => {
                  HandleSumbit(e);
                }}
                required
                name="doctor"
                value={user_info.doctor}
              >
                <option selected disabled value="">
                  Select a Doctor
                </option>
                {doctors.map((doctor) => {
                  return (
                    <option value={doctor.name} key={doctor.id}>
                      {doctor.name}
                    </option>
                  );
                })}
              </select>
            </div>
            
            {/* history */}
            <div className="col-12 col-md-6">
              <label htmlFor="history" className="form-label">
                History
              </label>
              <input
                type="text"
                className={`form-control ${style.inputChange}`}
                name="history"
                id="history"
                placeholder="enter the history"
                aria-describedby="inputGroupPrepend2"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("برجاء ادخال  الببانات او'--'")
                }
                onInput={(e) => e.target.setCustomValidity("")}
                value={user_info.history}
                onChange={HandleSumbit}
              />
            </div>
             {/* note */}
  <div className="col-12 col-md-6">
              <label htmlFor="Note" className="form-label">
                Note
              </label>
              <input
                type="text"
                className={`form-control ${style.inputChange}`}
                name="note"
                id="note"
                placeholder="enter the patient note"
                aria-describedby="inputGroupPrepend2"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("برجاء ادخال الملاحظات او'--'") 
                }
                onInput={(e) => e.target.setCustomValidity("")}
                value={user_info.note}
                onChange={HandleSumbit}
              />
            </div>
 
            {/* ward */}
            <div className="col-12">
              <label htmlFor="ward" className="form-label">
                ward
              </label>
              <input
                type="text"
                className={`form-control ${style.inputChange}`}
                name="ward"
                id="ward"
                placeholder="enter the patient ward"
                aria-describedby="inputGroupPrepend2"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("برجاء ادخال الجناح  ")
                }
                onInput={(e) => e.target.setCustomValidity("")}
                value={user_info.ward}
                onChange={HandleSumbit}
              />
            </div>
            {/* gender selection */}
            <div className="col-md-12 ">
              <label htmlFor="gender" className="form-label">
                gender
              </label>
              <div className="d-sm-flex justify-content-between">
                <div>
                  <div className={`${style.users} mb-2`}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="gender"
                      value="male"
                      onChange={HandleSumbit}
                      checked={user_info.gender === "male"}
                      id="male"
                    />
                    <label className="form-check-label ms-1" htmlFor="male">
                      Male
                    </label>
                  </div>
                  <div className={`${style.users} mb-2`}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="gender"
                      value="female"
                      onChange={HandleSumbit}
                      checked={user_info.gender === "female"}
                      id="female"
                    />
                    <label className="form-check-label ms-1" htmlFor="female">
                      female
                    </label>
                  </div>
          
                </div>
               
              </div>
            </div>
            {/*display error mesage  */}
            {message != "" ? (
              <div className={`${messageType} alert  text-center`} role="alert">
                {message}
              </div>
            ) : null}
            {/* submtion  */}
            <div className="col-12  text-center">
              <button className={`${Button_display} btn btn-dark`}>
                Add now
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUP;
